import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.recordedItem.isEncoding === true)?_c(VBtn,{staticClass:"ma-1",attrs:{"color":"teal white--text"},on:{"click":_vm.stopEncode}},[_c(VIcon,{attrs:{"left":"","dark":""}},[_vm._v("mdi-stop")]),_vm._v(" stop ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }